import axios from 'axios';
import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';
import { installRequestID, installSignedRequestAuth } from '@/api/interceptors';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { publicError } from 'shared/constants.json';

const getSentinelHost = () => {
  const host = window.location.host;
  if (host.includes('stage.x.mooncamp.com')) {
    return host.replace('stage', 'stage-auth');
  }
  if (host.endsWith('-bumblebee.mooncamp-dev.com')) {
    return host.replace('-bumblebee.mooncamp-dev.com', '-sentinel.mooncamp-dev.com');
  }
  return resolveEnvironmentVariable(environmentVariable.SENTINEL_HOST);
};

const BASE_URL = `https://${getSentinelHost()}/api/v1`;
const statusUnauthorized = 401;
const statusServiceUnavailable = 503;

export const httpclient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

const SentinelClientPlugin = {
  install: (app, { store }) => {
    if (!store) {
      throw new Error('SentinelClientPlugin requires a store instance.');
    }

    // --- Request Interceptor ---
    httpclient.interceptors.request.use(installRequestID);
    httpclient.interceptors.request.use(installSignedRequestAuth, (error) => Promise.reject(error));

    // --- Helper Functions ---
    const sendToLogin = (status, config) => {
      if (status !== statusUnauthorized) return false;
      return !['/api/v1/logout', '/logout'].includes(config.url);
    };

    // --- Response Interceptor ---
    httpclient.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (isNullOrUndefined(error.response)) {
          // we are probably offline
          // TODO: add offline handler
          return Promise.reject(error);
        }

        const { status, data, config } = error.response;

        // Maintenance Mode
        if (status === statusServiceUnavailable && typeof data === 'string' && data.includes(publicError.maintenanceMode)) {
          setTimeout(() => {
            store.commit('ENABLE_MAINTENANCE_MODE');
          }, 100);
        }

        // Unauthorized / Login redirect
        if (sendToLogin(status, config)) {
          setTimeout(() => {
            if (store.state.isLoggedIn) {
              store.dispatch('resetSession');
            }
          }, 100);
        }

        return Promise.reject(error);
      },
    );
  },
};

export default SentinelClientPlugin;
